import { MonitoringCockpitService } from '../../../../../../services/module'
import CockpitUtils from '../../../../../../components/monitoring-cockpit/utils'

class CockpitDecorator {
  path = '/monitoring-cockpit'

  showLog (monitoringID, date, integrationID, processType) {
    const query = { processType, date, integrationID, monitoringID }
    const params = new URLSearchParams(query)
    const route = `${origin}/monitoring-cockpit/show-log?${params}`
    open(route)
  }

  showLastLogs (integrationID, processType) {
    const isTheFlow = e => e.processType === processType && e.integrationID === integrationID

    MonitoringCockpitService.allIntegrations()
      .then(({ data }) => {
        const lastDate = data
          ?.filter(isTheFlow)
          .map(({ lastDate }) => lastDate)
          .pop() || CockpitUtils.rawDateNow()

        const startDate = CockpitUtils.dateBeforeThisDayNumber(lastDate, 7)
        const endDate = CockpitUtils.dateFormatHyphened(lastDate)

        const query = { processType, integrationID, startDate, endDate }

        const params = new URLSearchParams(query)
        const route = `${origin}/monitoring-cockpit/all-integration-logs?${params}`
        open(route)
      })
  }
}

export default new CockpitDecorator()
